/**
 * okra delete — Delete a document.
 *
 * Usage:
 *   okra delete <docId>
 *   okra delete <docId> --json
 */

import type { OkraClient } from '../../client';
import type { DeleteDocumentResult } from '../../types';
import type { GlobalFlags } from '../output';
import { Data, Effect } from 'effect';

export class DeleteCommandError extends Data.TaggedError('DeleteCommandError')<{
  readonly method: 'deleteDocument';
  readonly status?: number;
  readonly cause: unknown;
}> {}

function deleteDocumentEffect(
  client: OkraClient,
  documentId: string,
): Effect.Effect<DeleteDocumentResult, DeleteCommandError> {
  return Effect.tryPromise({
    try: () => client.deleteDocument(documentId),
    catch: (cause) => new DeleteCommandError({ method: 'deleteDocument', cause }),
  });
}

export async function deleteDocument(
  client: OkraClient,
  documentId: string,
  _opts: GlobalFlags,
): Promise<DeleteDocumentResult> {
  return Effect.runPromise(
    deleteDocumentEffect(client, documentId).pipe(
      Effect.catch((error) => Effect.fail(error.cause)),
    ),
  );
}
